import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"

export class AdminCommercialOriginMetrics {
  originType: ECommercialOriginType

  subscriptionsCount: number

  subscriptionsPercentage: number

  conversionRate: number

  activeSubscriptionsCount: number

  cancelledSubscriptionsCount: number

  totalRevenue: number

  monthlyRecurringRevenue: number

  constructor(data: Partial<AdminCommercialOriginMetrics> = {}) {
    this.originType = data.originType ?? ECommercialOriginType.Undefined
    this.subscriptionsCount = data.subscriptionsCount ?? 0

    this.subscriptionsPercentage = data.subscriptionsPercentage ?? 0

    this.conversionRate = data.conversionRate ?? 0

    this.activeSubscriptionsCount = data.activeSubscriptionsCount ?? 0

    this.cancelledSubscriptionsCount = data.cancelledSubscriptionsCount ?? 0

    this.totalRevenue = data.totalRevenue ?? 0

    this.monthlyRecurringRevenue = data.monthlyRecurringRevenue ?? 0
  }
}
